<template>
  <div>
    <report-summary
      :cases="cases"
      :title="title"
      :reportDistrict="reportDistrict"
      :reportDate="reportDate"
      :formName="formName"
      :appendixNumber="appendixNumber"
      :reportHeader="reportHeader"
    />
    <!-- <div
      class="report-viewer page-break"
      v-for="(page, index) in pages"
      :key="`page${index}`"
    >
      <div class="report-viewer-content">
        <div class="table-responsive">
          <table
            class="table table-sm table-bordered mb-0"
            id="headerTable"
            style="min-width: 100%"
          >
            <thead>
              <tr>
                <th
                  rowspan="5"
                  style="width: 16.66%"
                  class="text-center border-transparent-bottom"
                >
                  <img
                    src="@/assets/jkr.jpg"
                    class="w-100"
                    style="min-width: 80px"
                  />
                  <p class="mb-0 mt-2">JKR JOHOR</p>
                </th>
                <th
                  rowspan="5"
                  style="width: 49.99%; font-size: 1.3em"
                  class="text-center text-nowrap border-transparent-bottom"
                >
                  PROSEDUR PENYELIAAN KERJA RUTIN
                </th>
                <td style="width: 16.66%" class="text-nowrap">
                  No Ruj. Dokumen
                </td>
                <td style="width: 16.66%" class="text-center text-nowrap">
                  JKR.PK(SJ).P.01
                </td>
              </tr>
              <tr>
                <td style="width: 16.66%" class="text-nowrap">No. Keluaran</td>
                <td style="width: 16.66%" class="text-center text-nowrap">
                  00
                </td>
              </tr>
              <tr>
                <td style="width: 16.66%" class="text-nowrap">No. Pindaan</td>
                <td style="width: 16.66%" class="text-center text-nowrap">
                  00
                </td>
              </tr>
              <tr>
                <td style="width: 16.66%" class="text-nowrap">Tarikh</td>
                <td style="width: 16.66%" class="text-center text-nowrap">
                  {{ reportDate }}
                </td>
              </tr>
              <tr>
                <td
                  style="width: 16.66%"
                  class="text-nowrap border-transparent-bottom"
                >
                  Muka Surat
                </td>
                <td
                  style="width: 16.66%"
                  class="text-center text-nowrap border-transparent-bottom"
                >
                  {{ `${index + 1}/${pages.length}` }}
                </td>
              </tr>
            </thead>
          </table>
          <table
            class="table table-sm table-bordered mb-0"
            id="mainTable"
            style="min-width: 100%"
          >
            <thead>
              <tr>
                <th
                  colspan="2"
                  style="width: 50%"
                  class="border-transparent-right border-transparent-bottom"
                >
                  [{{ reportFormName }}]
                </th>
                <th
                  colspan="2"
                  style="width: 50%"
                  class="text-right border-transparent-bottom"
                >
                  LAMPIRAN {{ appendixNumber }}
                </th>
              </tr>
              <tr>
                <th
                  colspan="4"
                  class="
                    h6
                    py-0
                    font-weight-bold
                    text-center
                    border-transparent-top border-transparent-bottom
                  "
                >
                  {{ reportHeader }}
                </th>
              </tr>
              <tr>
                <th
                  colspan="4"
                  class="text-center border-transparent-top text-uppercase"
                >
                  LAPORAN BERGAMBAR
                  <span v-if="title">
                    {{ title }}
                  </span>
                  <span class="font-weight-light font-italic text-muted" v-else>
                    Report name not specified
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-uppercase">NEGERI</td>
                <td class="text-uppercase">{{ state }}</td>
                <td class="text-uppercase">DAERAH</td>
                <td class="text-uppercase">
                  {{ reportDistrict }}
                </td>
              </tr>

              <template v-for="(p, pageIndex) in page">
                <tr :key="`${pageIndex}-info`">
                  <template v-for="c in p">
                    <td :key="`${c._id}-title`">NAMA JALAN</td>
                    <td :key="`${c._id}-text`" class="text-uppercase">
                      {{ c.road ? c.road.name : "" }}
                    </td>
                  </template>
                </tr>
                <tr :key="`${pageIndex}-section`">
                  <template v-for="c in p">
                    <td :key="`${c._id}-title`">SEKSYEN</td>
                    <td :key="`${c._id}-text`">
                      {{
                        c.lat && c.lng ? formatCoordinate([c.lat, c.lng]) : ""
                      }}
                    </td>
                  </template>
                </tr>
                <tr :key="`${pageIndex}-image`" class="report-case-image">
                  <template v-for="c in p">
                    <td :key="`${c._id}-1`" colspan="2" style="width: 50%">
                      <img
                        :src="c.media[c.media.length - 1].url"
                        v-if="c.media && c.media[c.media.length - 1]"
                      />
                    </td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import moment from "moment";
import Helper from "@/helper";
import ReportSummary from "@/components/report-templates/Summary";

export default {
  name: "report-template-default",
  props: ["cases", "title", "district", "header", "formName"],
  components: {
    ReportSummary,
  },
  data() {
    return {
      pages: [],
      state: "JOHOR",
      reportDistrict: "",
      reportHeader: "",
      reportFormName: "",
      reportDate: moment().format("DD MMM YYYY"),
    };
  },
  computed: {
    appendixNumber() {
      if (this.reportFormName) {
        const formName = this.reportFormName.split("-");
        return formName[formName.length - 1];
      } else {
        return "";
      }
    },
  },
  watch: {
    cases: {
      handler() {
        this.$emit("reportLoaded", false);

        if (this.cases.length > 0) {
          this.pages = [];

          let cases = [];

          if (this.cases.length > 0) {
            JSON.parse(JSON.stringify(this.cases)).forEach((c) => {
              if (
                cases[cases.length - 1] &&
                cases[cases.length - 1].length < 2
              ) {
                cases[cases.length - 1].push(c);
              } else {
                cases.push([c]);
              }
            });

            cases.forEach((c) => {
              if (
                this.pages[this.pages.length - 1] &&
                this.pages[this.pages.length - 1].length < 3
              ) {
                this.pages[this.pages.length - 1].push(c);
              } else {
                this.pages.push([c]);
              }
            });

            let lastPage = this.pages[this.pages.length - 1];

            let lastGroupInLastPage = lastPage[lastPage.length - 1];

            if (lastGroupInLastPage.length < 2) {
              lastGroupInLastPage.push({ _id: "lastInGroup" });
            }

            if (lastPage.length < 3) {
              for (let index = 0; index < 4 - lastPage.length; index++) {
                lastPage.push([{ _id: "lastPage1" }, { _id: "lastPage2" }]);
              }
            }
          }

          this.reportDistrict = this.district;
          this.reportHeader = this.header;
          this.reportFormName = this.formName;

          this.$nextTick(() => {
            let reportContainer = document.getElementById("reportContainer");

            if (reportContainer) {
              reportContainer.scrollTop = 0;
            }

            this.setWidth();

            window.removeEventListener("resize", this.setWidth, true);

            window.addEventListener("resize", this.setWidth, true);

            this.$emit("reportLoaded", true);
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    formatCoordinate(coord) {
      return Helper.formatCoordinate(coord);
    },
    setWidth() {
      let mainTable = document.getElementById("mainTable");
      let headerTable = document.getElementById("headerTable");

      if (mainTable && headerTable) {
        if (mainTable > headerTable) {
          headerTable.style.width = `${mainTable.clientWidth}px`;
        } else {
          mainTable.style.width = `${headerTable.clientWidth}px`;
        }
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setWidth, true);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/print.scss";
</style>